export const usePreventDragging = ({ref, effect}) => {
    const preventDragging = (dragging) => {
        let node = ref.current
            .parentNode;
        let found = 0;
        for (let i=0; i < 20; i++) {
            if (!node) {
                break;
            }
            if (node.className && node.className.includes("effect") && !node.className.includes("inner-effect") &&
                !node.className.includes("effects-view") && 
                !node.className.includes( "effect-rack")) {
                node.setAttribute("draggable", dragging);
                // return;
            }
            node = node.parentNode;
        }
    };

    return {preventDragging};
};
